export default "/list/static/images/custom-marker-2.png";